/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-05-26 16:04:55
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-06-08 11:19:54
 * @FilePath: /dsicm-admin-web/src/views/StandardDatabase/common/form.config.js
 */
export default{
    data(){
        return{
            addFoodrules: {
                name: [
                    { required: true, message: '请输入菜肴名称', trigger: 'blur' },
                ],
                abbreviation: [
                    { required: true, message: '请输入菜肴简称', trigger: 'blur' },
                ],
                delicaciesBigId: [
                    { required: true, message: '请选择菜肴大类', trigger: 'change' }
                ],
                delicaciesSmallId: [
                    { required: true, message: '请选择菜肴小类', trigger: 'change' }
                ],
                status: [
                    { required: true, message: '请选择菜肴状态', trigger: 'change' }
                ]
            }
        }
    }
}
